import { render, staticRenderFns } from "./ButtonDemo.vue?vue&type=template&id=1ecbed10&scoped=true&"
import script from "./ButtonDemo.vue?vue&type=script&lang=js&"
export * from "./ButtonDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecbed10",
  null
  
)

export default component.exports